import { create } from 'zustand'

import type { WalletCurrency } from '@/domain'
import type { FiatAmount } from '@/types'

interface StoreState {
  triggerShake: boolean
  fiatAmount: FiatAmount
  sharesAmount: number
  selectedCryptoWalletData?: WalletCurrency
}

interface StoreFunctions {
  shakeComponent: () => void
  setSelectedCryptoWalletData: (
    selectedCryptoWalletData: WalletCurrency,
  ) => void
  setFiatAmount: (fiatAmount?: FiatAmount) => void
  setSharesAmount: (sharesAmount: number) => void
  resetBuyStocksStore: VoidFunction
}

export type BuyStocksStore = StoreState & StoreFunctions

const initialState: StoreState = {
  triggerShake: false,
  selectedCryptoWalletData: undefined,
  sharesAmount: 0,
  fiatAmount: {
    amount: '0',
    code: 'USD',
  },
}

export const useBuyStocksStore = create<BuyStocksStore>()((set) => ({
  ...initialState,
  setFiatAmount: (fiatAmount) => set({ fiatAmount }),
  setSharesAmount: (sharesAmount) => set({ sharesAmount }),
  setSelectedCryptoWalletData: (selectedCryptoWalletData) =>
    set({ selectedCryptoWalletData }),
  shakeComponent: () => {
    set({ triggerShake: true })
    setTimeout(() => set({ triggerShake: false }), 600)
  },
  resetBuyStocksStore: () => set({ ...initialState }),
}))
